import { StudentClassType } from "../../../types/Student";
import { put } from "../../../utils/axios-config";
import { STUDENT_CLASSES } from "../../../utils/constants";

export const updateStudentClass = async (data: StudentClassType) => await put<StudentClassType, boolean>(STUDENT_CLASSES, data);